import { HttpCustomQuotationList, HttpDeleteCustomQuotation } from '@/service/tasks';
import TableList from "@components/templates/tablelist";
import comIndex from './update'
import compDetail from '../receiveoffer/update.vue';

import { mapGetters } from 'vuex';
import mixin from '../mixin';
export default {
    mixins: [TableList, mixin],
    components: {
        comIndex,
        compDetail
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            formData: {},
            exportData: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpCustomQuotationList,
        interceptRequest(params) {
            const { IN_orgWarehouseCode, templateCode, GE_validity } = params.search;
            params.search.LE_startDate = GE_validity;
            params.search.GE_endDate = GE_validity;
            // params.orgWarehouseCode = IN_orgWarehouseCode;
            params.code = templateCode;
            // delete params.search.IN_orgWarehouseCode;
            delete params.search.templateCode;
            delete params.search.GE_validity;
            delete params.search.undefined;
            this.exportData = params;
            return params;
        },
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'add':
                    this.$router.push({
                        name: 'customerQuotationUpdate',
                        params: { type: "add" },
                    });
                    break;
                case 'query':
                    var url = this.$router.resolve({
                        name: "customerQuotationUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "edit":
                    this.$router.push({
                        name: 'customerQuotationUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: 'warning',
                        params: { id: params },
                        title: this.$t('global.common.delete', { defaultValue: '删除' }),
                        ajaxRequest: HttpDeleteCustomQuotation,
                        desc: this.$t('fbb.localemanage.confirm_delete', { defaultValue: '删除后不可恢复，是否确认删除？' }),
                    }
                    break;
                case "queryTemplate":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "compDetail",
                        activeid: params,
                        querytype:'query',
                        showFooter: false
                    }
                    break;
                case "queryBlankTemplate":
                    var urlTemplate = this.$router.resolve({
                        name: "tasksReceiveofferUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(urlTemplate.href, '_blank');
                    break;
                case 'export':
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/billing/priceReceivable/batchExport", this.exportData,
                        { executor: 'request', download: true }
                    );
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    show: true,
                    params: id,
                    operate: 'query'
                },
                {
                    label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                    show: true,
                    params: id,
                    operate: 'edit'
                },
                {
                    label: this.$t('global.common.delete', { defaultValue: '删除' }),
                    show: true,
                    params: id,
                    operate: 'delete'
                }
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getAdminTransferWarehouse', 'getCusproductList']),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "导出",
                    operate: "export",
                },
            ]
        },
        SearchsData() {
            return [
                // {
                //     label: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                //     key: 'EQ_organizationId',
                //     tag: 'Select',
                //     options: this.getBillcusorgList,
                //     props: {
                //         filterable: true,
                //     },
                //     show: true,
                //     style: "width:250px",
                // },
                {
                    label: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    tag: 'div',
                    show:true,
                    children:(h)=>{
                        return h("compMultipleSelect",{
                            props: {
                                options:this.getBillcusorgList,
                                modelValue:this.formData.search.IN_organizationId,
                                placeholder:this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                                isShowCheckAll:false,//是否展示全选按钮
                            },
                            on:{
                                'update:modelValue':(val)=>{
                                    this.formData.search.IN_organizationId = val
                                }
                            }
                        })
                    },
                    style: "width:250px",
                },
                // {
                //     label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                //     key: 'IN_orgWarehouseCode',
                //     tag: 'Select',
                //     options: this.getAdminTransferWarehouse ,
                //     props: {
                //         filterable: true,
                //     },
                //     show: true,
                //     style: "width:250px",
                // },
                {
                    label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                    tag: 'div',
                    show:true,
                    children:(h)=>{
                        return h("compMultipleSelect",{
                            props: {
                                options:this.getAdminTransferWarehouse,
                                modelValue:this.formData.search.IN_orgWarehouseCode,
                                placeholder:this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                                isShowCheckAll:false,//是否展示全选按钮
                            },
                            on:{
                                'update:modelValue':(val)=>{
                                    this.formData.search.IN_orgWarehouseCode = val
                                }
                            }
                        })
                    },
                    style: "width:250px",
                },
                // {
                //     label: this.$t('global.common.line', { defaultValue: '项目' }),
                //     key: 'IN_lineId',
                //     tag: 'Select',
                //     options: this.getCusproductList,
                //     props: {
                //         filterable: true,
                //         multiple: true,
                //     },
                //     show: true,
                //     style: "width:250px",
                // },
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    tag: 'div',
                    show:true,
                    children:(h)=>{
                        return h("compMultipleSelect",{
                            props: {
                                options:this.getCusproductList,
                                modelValue:this.formData.search.IN_lineId,
                                placeholder:this.$t('global.common.line', { defaultValue: '项目' }),
                                isShowCheckAll:false,//是否展示全选按钮
                            },
                            on:{
                                'update:modelValue':(val)=>{
                                    this.formData.search.IN_lineId = val
                                }
                            }
                        })
                    },
                    style: "width:250px",
                },
                {
                    label: "报价模板",
                    key: 'templateCode',
                    tag: 'Input',
                    style: "width:250px",
                },
                {
                    label: "有效期",
                    tag: 'vDatepicker',
                    style: "width:250px",
                    key: 'GE_validity',
                    props: {
                        format: 'yy-mm-dd',
                        confirm: false,
                    },
                }
            ]
        },
        columns() {
            return [
                {
                    type: "index",
                    title: "No.",
                    width: 60,
                    align: "center",
                },
                {
                    title: '操作',
                    width: 80,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'organizationId',
                    render: (h, { row }) => {
                        const org = this.getBillcusorgList.filter( item=> item.value === row.organizationId)[0] || {};
                        return <div>{org.label || '--'}</div>
                    }
                },
                {
                    title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                    render: (h, { row }) => {
                        let orgWarehouseCode = row.orgWarehouseCode
                        const { label } = this.getAdminTransferWarehouse.find(function (item) { return item.attach.code == orgWarehouseCode}) || '--';
                        return <div>{label}</div>
                    }
                },
                {
					title: this.$t('global.common.line', { defaultValue: '项目' }),
					key: 'lineId',
					render: (h, { row }) => {
						const data = this.getCusproductList.find(item => item.value == row.lineId) || {};
						return data.label || '--'
					},
				},
                {
                    title: "作业费报价模板",
                    key: 'billingOperationPriceTemplateId',
                    render: ( h, { row } ) => {
                        const template = this.allTemplate.find(item => item.id === row.billingOperationPriceTemplateId) || {};
                        if(!template.code){
                            return '--'
                        }else{
                            return <div>
                                <a onClick={this.handleOperates.bind(this, row.billingOperationPriceTemplateId, 'queryTemplate')}>{`${template.code || '--'}(${template.name || '--'})`}</a><span style="color: rgba(53,14,14,0.82)">{`${template.status == 0 ? '-已禁用' : ''}`}</span>
                                <a onClick={this.handleOperates.bind(this, row.billingOperationPriceTemplateId, 'queryBlankTemplate')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                        }
                    }
                },
                {
                    title: "仓储费报价模板",
                    key: 'billingStoragePriceTemplateId',
                    render: ( h, { row } ) => {
                        const template = this.allTemplate.find(item => item.id === row.billingStoragePriceTemplateId) || {};
                        if(!template.code){
                            return '--'
                        }else{
                            return <div>
                                <a onClick={this.handleOperates.bind(this, row.billingStoragePriceTemplateId, 'queryTemplate')}>{`${template.code || '--'}(${template.name || '--'})`}</a><span style="color: rgba(53,14,14,0.82)">{`${template.status == 0 ? '-已禁用' : ''}`}</span>
                                <a onClick={this.handleOperates.bind(this, row.billingStoragePriceTemplateId, 'queryBlankTemplate')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                        }
                    }
                },
                {
                    title: "增值费报价模板",
                    key: 'billingValueAddedPriceTemplateId',
                    render: ( h, { row } ) => {
                        const template = this.allTemplate.find(item => item.id === row.billingValueAddedPriceTemplateId) || {};
                        if(!template.code){
                            return '--'
                        }
                        else{
                            return <div>
                                <a onClick={this.handleOperates.bind(this, row.billingValueAddedPriceTemplateId, 'queryTemplate')}>{`${template.code || '--'}(${template.name || '--'})`}</a><span style="color: rgba(53,14,14,0.82)">{`${template.status == 0 ? '-已禁用' : ''}`}</span>
                                <a onClick={this.handleOperates.bind(this, row.billingValueAddedPriceTemplateId, 'queryBlankTemplate')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                        }
                    }
                },
                {
                    title: "有效期",
                    render: (h, { row }) => {
						return <div>{row.startDate}-{row.endDate}</div>
					},
                },
                {
                    title: "更新时间",
                    key: 'updatedAt',
                }];
        },
    },
};




